// extracted by mini-css-extract-plugin
module.exports = {"eliteWhyChooseWrapper":"_2NnPo","howitImage":"_1rzCI","eliteWhyCard":"_1FkQB","cardWrapper":"_3K15t","cardText":"_2Hv1T","titleWrapper":"_3KHn-","text":"Zv1q9"};